var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "error" }, [
      _c("span", { staticClass: "nofound" }, [_vm._v("404")]),
      _vm._v(" "),
      _c("span", [_vm._v("输入的网址不正确或服务已过期")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!./node_modules/vue-loader/lib??vue-loader-options!./src/components/error.vue?vue&type=template&id=ea0f4bb0&scoped=true&
// module id = null
// module chunks = 